import React from 'react';

import { IFormDataInPaystatement, IPayItemInPaystatement } from 'types/salary';

interface IProps {
  NAME: string;
  PAYDATA: IFormDataInPaystatement;
  HandlePayInput: (e: React.ChangeEvent<HTMLInputElement>, isSecondDefaultPay?: boolean) => void; //금액입력
  HandlePayInput2: (e: React.ChangeEvent<HTMLInputElement>, isSecondDefaultPay?: boolean) => void; // 시간,분입력
  PAYTYPE: string;
  handlePay: (e: React.KeyboardEvent<HTMLInputElement>, isSecondDefaultPay?: boolean) => void;
  payAutoSum: (isSecondDefaultPay?: boolean) => void;
  AddZeroValue: (NAME: any) => void;
}

const SectionWorkTimeInput = ({
  NAME,
  PAYDATA,
  HandlePayInput, //금액입력
  HandlePayInput2, // 시간,분입력
  PAYTYPE,
  handlePay,
  payAutoSum,
  AddZeroValue,
}: IProps) => {
  let VALUE = PAYDATA[NAME];
  let VALUE2 = PAYDATA[NAME];
  let VALUE3 = PAYDATA[NAME];
  let VALUE4 = PAYDATA[NAME];
  let VALUE5 = PAYDATA[NAME];
  let VALUENAME1 = NAME;
  let VALUENAME2 = '';
  let VALUENAME3 = '';
  let VALUENAME4 = '';
  let VALUENAME5 = '';
  if (NAME == '기본급') {
    if (PAYTYPE == '시급') {
      VALUE = PAYDATA['근무시간'];
      VALUE2 = PAYDATA['근무분'];
      VALUE3 = PAYDATA['시급'];
      VALUE4 = PAYDATA['주휴수당시간'];
      VALUE5 = PAYDATA['주휴수당분'];
      VALUENAME1 = '근무시간';
      VALUENAME2 = '근무분';
      VALUENAME3 = '시급';
      VALUENAME4 = '주휴수당시간';
      VALUENAME5 = '주휴수당분';
    } else if (PAYTYPE == '일급') {
      VALUE = PAYDATA['근무일수'];
      VALUE2 = PAYDATA['일급'];
      VALUENAME1 = '근무일수';
      VALUENAME2 = '일급';
    } else {
      VALUE = PAYDATA['근무시간'];
      VALUE2 = PAYDATA['근무분'];
      VALUENAME1 = '근무시간';
      VALUENAME2 = '근무분';
    }
  }
  if (NAME == '연장근로수당') {
    VALUE = PAYDATA['연장근로시간'];
    VALUE2 = PAYDATA['연장근로분'];
    VALUENAME1 = '연장근로시간';
    VALUENAME2 = '연장근로분';
  }
  if (NAME == '야간근로수당') {
    VALUE = PAYDATA['야간근로시간'];
    VALUE2 = PAYDATA['야간근로분'];
    VALUENAME1 = '야간근로시간';
    VALUENAME2 = '야간근로분';
  }
  if (NAME == '휴일근로수당') {
    VALUE = PAYDATA['휴일근로시간'];
    VALUE2 = PAYDATA['휴일근로분'];
    VALUENAME1 = '휴일근로시간';
    VALUENAME2 = '휴일근로분';
  }
  if (VALUE === undefined) VALUE = '';
  if (VALUE2 === undefined) VALUE2 = '';
  if (VALUE3 === undefined) VALUE3 = '';
  if (VALUE4 === undefined) VALUE4 = '';
  if (VALUE5 === undefined) VALUE5 = '';

  return (
    <div className="SectionPayInput">
      {NAME == '기본급' ? (
        PAYTYPE == '시급' ? (
          <>
            <div className="SectionPayInner">
              <span>시간</span>
              <input
                type="text"
                name={VALUENAME1}
                className="W30"
                maxLength={3}
                value={VALUE}
                onChange={HandlePayInput2}
                onBlur={() => payAutoSum()}
              />
            </div>
            <div className="SectionPayInner">
              <span>분</span>
              <input
                type="text"
                name={VALUENAME2}
                className="W30"
                maxLength={2}
                value={VALUE2}
                onChange={HandlePayInput2}
                onBlur={() => payAutoSum()}
              />
            </div>
            <div className="SectionPayInner">
              <span>시급</span>
              <input
                type="text"
                name={VALUENAME3}
                className="W40"
                maxLength={6}
                onChange={HandlePayInput}
                value={VALUE3}
                onKeyUp={handlePay}
                onBlur={() => payAutoSum()}
              />
            </div>
            <div className="SectionPayInner">
              <span>주휴수당시간</span>
              <input
                type="text"
                name={VALUENAME4}
                className="W30"
                maxLength={3}
                value={VALUE4}
                onChange={HandlePayInput2}
                onBlur={() => payAutoSum()}
              />
            </div>
            <div className="SectionPayInner">
              <span>주휴수당분</span>
              <input
                type="text"
                name={VALUENAME5}
                className="W30"
                maxLength={3}
                value={VALUE5}
                onChange={HandlePayInput2}
                onBlur={() => payAutoSum()}
              />
            </div>
          </>
        ) : PAYTYPE == '일급' ? (
          <>
            <div className="SectionPayInner">
              <span>근무일수</span>
              <input
                type="text"
                name={VALUENAME1}
                className="W30"
                maxLength={3}
                value={VALUE}
                onChange={HandlePayInput2}
                onBlur={() => payAutoSum()}
              />
            </div>
            <div className="SectionPayInner">
              <span>일급</span>
              <input
                type="text"
                name={VALUENAME2}
                className="W50"
                maxLength={8}
                onChange={HandlePayInput}
                value={VALUE2}
                onKeyUp={handlePay}
                onBlur={() => payAutoSum()}
              />
            </div>
          </>
        ) : (
          <>
            <div className="SectionPayInner">
              <span>시간</span>
              <input
                type="text"
                name={VALUENAME1}
                className="W30"
                maxLength={3}
                value={VALUE}
                onChange={HandlePayInput2}
                onBlur={AddZeroValue}
              />
            </div>
            <div className="SectionPayInner">
              <span>분</span>
              <input
                type="text"
                name={VALUENAME2}
                className="W30"
                maxLength={2}
                value={VALUE2}
                onChange={HandlePayInput2}
                onBlur={AddZeroValue}
              />
            </div>
          </>
        )
      ) : (
        <>
          <div className="SectionPayInner">
            <span>시간</span>
            <input
              type="text"
              name={VALUENAME1}
              className="W30"
              maxLength={3}
              value={VALUE}
              onChange={HandlePayInput2}
              onBlur={AddZeroValue}
            />
          </div>
          <div className="SectionPayInner">
            <span>분</span>
            <input
              type="text"
              name={VALUENAME2}
              className="W30"
              maxLength={2}
              value={VALUE2}
              onChange={HandlePayInput2}
              onBlur={AddZeroValue}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default SectionWorkTimeInput;
